import React from 'react'
import Moment from 'react-moment'
import { Divider, Button } from 'semantic-ui-react'

import { Cont, ContDetail } from './styled'

export const ProcessRow = ({ data, files }) => {
  return (
    <Cont>
      <ContDetail>
        <div>Commented by : </div>
        <div>{data && data.createdByName}</div>
      </ContDetail>
      <ContDetail>
        <div>Commented date : </div>
        <div><Moment format="DD MMM YYYY HH:mm">{data && data.createdDate}</Moment></div>
      </ContDetail>
      <ContDetail>
        <div>Activity : </div>
        <div>{data && data.activity}</div>
      </ContDetail>
      <ContDetail>
        <div>Action : </div>
        <div>{data && data.action}</div>
      </ContDetail>
      <ContDetail>
        <div>Comment : </div>
        <div>{data && data.comment || '-'}</div>
      </ContDetail>
      {files &&
        <ContDetail>
          <div>Attachment : </div>
          <div className='fileList'>
            {
              files && files.map((item) => {
                return (
                  <Button type='button' content={<div className='fileName'>{item.originalFilename}</div>} icon='download' labelPosition='left' onClick={() => (window.open(item.urlPath, "_blank"))} />
                )
              })
            }
          </div>
        </ContDetail>
      }
      <Divider />
    </Cont>
  )
}